import React, { useRef, Children } from 'react';
import { motion, useInView } from 'framer-motion';
import { PhoneIcon, MailIcon } from 'lucide-react';
const fadeUpVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
};
export function AgentSection() {
  const ref = useRef<HTMLElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <section ref={ref} id="contact" className="w-full bg-dark px-6 py-20 md:py-26" aria-label="Agent contact information" data-id="element-19">
      <motion.div className="mx-auto max-w-xl text-center" initial="hidden" animate={isInView ? 'visible' : 'hidden'} variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.1,
          delayChildren: 0.1
        }
      }
    }} data-id="element-20">
        <motion.p className="font-heading text-xs font-bold tracking-widest-plus uppercase text-accent mb-4" variants={fadeUpVariants} data-id="element-21">
          Contact
        </motion.p>

        <motion.h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-12" variants={fadeUpVariants} data-id="element-22">
          Presented By
        </motion.h2>

        {/* Agent portrait */}
        <motion.div className="mx-auto mb-8 h-40 w-40 overflow-hidden rounded-full border-2 border-white/10 bg-dark-light shadow-xl" variants={fadeUpVariants} data-id="element-23">
          <img src="https://cdn.magicpatterns.com/uploads/qn18jmjDuXTU2Bc6ph5QCR/Dylan_Kilner_2024.png" alt="Dylan Kilner" className="h-full w-full object-cover" data-id="element-24" />
        </motion.div>

        <motion.h3 className="font-heading text-2xl font-bold text-white mb-2" variants={fadeUpVariants} data-id="element-25">
          Dylan Kilner
        </motion.h3>

        <motion.p className="font-body text-sm text-white/50 tracking-wide mb-1" variants={fadeUpVariants} data-id="element-26">
          Director, City Fringe Sales
        </motion.p>

        <motion.p className="font-body text-sm text-white/50 tracking-wide mb-8" variants={fadeUpVariants} data-id="element-27">
          Stonebridge Property Group
        </motion.p>

        {/* Stonebridge logo */}
        <motion.div className="mb-8" variants={fadeUpVariants} data-id="element-28">
          <img src="https://cdn.magicpatterns.com/uploads/neNaCNBs6EW2ecQoy3yAp9/Stonebridge_logo_master_reversed_1.0.png" alt="Stonebridge Property Group" className="mx-auto h-6 w-auto opacity-50" data-id="element-29" />
        </motion.div>

        {/* Contact details */}
        <motion.div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-10" variants={fadeUpVariants} data-id="element-30">
          <a href="tel:+61459396341" className="flex items-center gap-2.5 font-body text-sm text-white/60 transition-colors duration-200 hover:text-white" data-id="element-31">
            <PhoneIcon size={15} strokeWidth={1.5} className="text-accent" aria-hidden="true" data-id="element-32" />
            +61 459 396 341
          </a>
          <a href="mailto:dkilner@stonebridge.com.au" className="flex items-center gap-2.5 font-body text-sm text-white/60 transition-colors duration-200 hover:text-white" data-id="element-33">
            <MailIcon size={15} strokeWidth={1.5} className="text-accent" aria-hidden="true" data-id="element-34" />
            dkilner@stonebridge.com.au
          </a>
        </motion.div>

        <motion.p className="font-body text-base text-white/40 mb-10" variants={fadeUpVariants} data-id="element-35">
          For a private inspection, please enquire directly
        </motion.p>

        {/* CTA Button */}
        <motion.div variants={fadeUpVariants} data-id="element-36">
          <a href="mailto:dkilner@stonebridge.com.au?subject=Enquiry%20—%20120-124%20Dryburgh%20Street%2C%20North%20Melbourne" className="inline-block rounded-full bg-accent px-10 py-4 font-heading text-xs font-bold uppercase tracking-widest-plus text-white transition-colors duration-200 hover:bg-accent-dark" role="button" data-id="element-37">
            Request Information
          </a>
        </motion.div>

        {/* Footer */}
        <motion.div className="mt-20" variants={fadeUpVariants} data-id="element-38">
          <div className="mx-auto mb-6 h-px w-16 bg-white/10" aria-hidden="true" data-id="element-39" />
          <p className="font-body text-xs text-white/25 tracking-wide" data-id="element-40">
            &copy; 2026 Stonebridge Property Group. All rights reserved.
          </p>
        </motion.div>
      </motion.div>
    </section>;
}